module.exports = __webpack_public_path__ + "f77669fad782d27717256fe516634b99.svg";